import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { Menu, Spin } from 'antd'
import Button from 'components/Button'
import TableSearchFilter from '../../../components/UIComponents/TableSearchFilter'
import './style.css'
import { FONT } from 'theme/font'

export const SubFLex = styled(Flex)`
flex-direction: ${props => (props.flexDirection ? props.flexDirection : '')};
  ${props => props.gap && `gap: ${props.gap};`}
  ${props => props.marginBottom && ` margin-bottom: ${props.marginBottom};`};
  ${props => props.paddingTop && ` padding-top: ${props.paddingTop};`};
  ${props => props.flexWrap && ` flex-wrap: ${props.flexWrap};`};

`

export const SecondGreyText = styled.p`
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '8px')};
  margin-left: ${props => (props.marginLeft ? props.marginLeft : '0')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '0')};
  font-style: normal;
  font-style: normal;
  font-weight: 600;
  font-size: 0.875em;
  line-height: 1.125em;
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  cursor: ${props => (props.pointer ? 'pointer' : 'default')};
  color: ${props => (props.color ? props.color : COLORS.GREY_T_40)};
`

export const StudentName = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 700;
  font-size: 1.125em;
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    font-size: 0.875em;
  }
`
export const CollegeName = styled.p`
  margin-bottom: 0;
  font-style: normal;
  font-weight: 600;
  font-size: 0.975em;
  line-height: 18px;
  letter-spacing: 0.1em;
  color: ${COLORS.GREY_T_50};
  display: flex;
  gap: 10px;
  align-items: center;
  word-wrap: break-word;
  @media (max-width: 768px) {
    font-size: 0.576em;
    gap: 5px;
  }

  @media (max-width: 480px) {
    font-size: 0.875em;
    gap: 3px;
  }
`
export const EmptyDivElement = styled.div`
  width: auto;
`

export const HeaderFlexOne = styled(Flex)`
  gap: 10px;
  width: 'max-content';
`
export const InfoSection = styled(Flex)`
  gap: 5px;
  margin-left: 10px;
`

export const OtherFlex = styled(Flex)`
  width: ${props => (props.width ? props.width : '25%')};
  margin-right: 30px;
`

export const FooterFlex = styled(Flex)`
  gap: 20px;
`

export const ActionButton = styled(Button.Outline)(
  ({
    color,
    staticColor,
    borderNone,
    bgColor,
    decoration,
    fontColor,
    fontSize,
    customHeight,
    disable,
    marginBottom,
  }) => ({
    border: disable
      ? '1px solid #D1D5DB'
      : borderNone
      ? 'none'
      : staticColor
      ? `1px solid ${staticColor}`
      : color === 'secondary'
      ? '1px solid #5DB594'
      : '1px solid #3249D7',
    boxShadow: '0px 1px 2px 0px #1018280D',
    padding: '9px, 20px, 9px, 20px',
    borderRadius: '10px',
    background: disable ? '#F1F1F1' : bgColor ?? '#FFFFFF',
    color: disable
      ? '#B8B8B8'
      : fontColor
      ? fontColor
      : staticColor
      ? staticColor
      : color === 'secondary'
      ? '#5DB594'
      : '#3249D7',
    height: customHeight ?? 37,
    '&:hover': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },
    marginBottom: marginBottom ?? 'unset',
    ' &:focus': {
      background: bgColor ?? '#FFFFFF',
      border: borderNone
        ? 'none'
        : staticColor
        ? `1px solid ${staticColor}`
        : color === 'secondary'
        ? '1px solid #5DB594'
        : '1px solid #3249D7',
      color: fontColor
        ? fontColor
        : staticColor
        ? staticColor
        : color === 'secondary'
        ? '#5DB594'
        : '#3249D7',
    },

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: decoration ?? 'none',
    fontWeight: 600,
    fontSize: fontSize ?? 'unset',
  })
)

export const EmptyWrapper = styled(Flex)`
  margin: 50px 0px;
  margin: ${props => props?.isSpin && '102px 0px'};
`

export const SectionWrapper = styled(Flex)`
  width: 100%;
  ${''}
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  height: calc(100vh - 142px);
  overflow: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #cccccc;
  }
  padding: 10px 15px;
`

export const Container = styled(Flex)`
  padding: 20px 25px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  background-color: #ffffff;
  z-index: 99;
  position: sticky !important;
  top: 0 !important;
`
export const Main = styled.div`
  position: sticky;
  top: 0;
  z-index: 1001;
`
export const LeftSection = styled(Flex)`
  gap: 20px;
  flex-wrap: wrap;
`
export const RightSection = styled(Flex)`
  justify-content: flex-end;
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #4d566e;
`
export const JobDetailsSpan = styled.span`
  font-size: 12px;
  color: ${COLORS.GREY_T_60};
  padding-left: 10px;
`

export const HeaderFullWidth = styled.div`
  width: 100%;
`

export const JobRoleFlex = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
`

export const JobRoleWholeFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
export const CustomButtonSecondary = styled(Button.Secondary)`
  color: rgba(93, 181, 148, 1);
  border-color: rgba(93, 181, 148, 1);

  &:hover {
    color: rgba(93, 181, 148, 1);
    border-color: rgba(93, 181, 148, 1);
  }

  &:active {
    border-color: rgba(93, 181, 148, 1);
  }
`

export const StyledTableSearchFilter = styled(TableSearchFilter)`
  margin-top: 14%;
`

export const StyledImage = styled.img`
  width: 400px;
  height: 360px;
  margin-left: 35%;
  margin-top: 5%;
`
export const BoldText = styled.p`
  font-weight: bold;
  width: max-content;
  margin-top: 5px;
`
export const ShipText = styled.div`
  border: 1px solid #3249d7;
  border-radius: 14px;
  font-size: 10px;
  color: #000000;
  padding: 1px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-right: 10px;
  height: 32px;
  margin-bottom: 10px;
`
export const FilterLabel = styled.p`
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  white-space: ${props => (props.whiteSpace ? props.whiteSpace : '')};
`
export const MultiPadding = styled.div`
  padding: 1rem 0px;
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const CustomDateRangeContainer = styled.div`
  position: relative;

  .calendarWrap .rdrCalendarWrapper {
    pointer-events: none;
  }
  .rdrStaticRangeLabel {
    font-size: 10px;
    padding: 10px;
  }
  .rdrInputRanges {
    display: none;
  }
  .rdrDefinedRangesWrapper {
    width: 150px;
  }
  .rdrDateDisplayWrapper {
    display: none;
  }
  .rdrMonthAndYearPickers {
    display: none;
  }
  .rdrMonth {
    width: 20em;
    padding: 0;
  }
  .rdrMonthAndYearWrapper {
    height: unset;
  }
  .rdrMonthName {
    text-align: center;
    color: #1f2937;
  }
  .rdrInRange {
    background: #f4f4f4;
    color: #1f2937;
  }
  .rdrStartEdge {
    background: #3249d7;
  }
  .rdrEndEdge {
    background: #3249d7;
  }
  .rdrDay {
    height: 2.5em;
    @media (min-width: 1000px) {
      height: 3em;
    }
  }
  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
    color: #000;
  }
  .rdrNextPrevButton {
    background: #fff;
  }
`

export const PositionBox = styled.div`
  position: absolute;
  bottom: 15px;
  left: 5px;
`

export const CustomizeMenu = styled(Menu)`
  .ant-dropdown-menu-item {
    font-weight: 700;
  }
  .ant-dropdown-menu-title-content {
    width: max-content;
  }
`
export const CustomSpin = styled(Spin)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
`

export const CustomExportButton = styled(Button.Secondary)`
  border: 1px solid ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
  color: ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
  height: 35px;

  &:hover {
    border: 1px solid ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
    color: ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
  }
  &:focus {
    border: 1px solid ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
    color: ${props => props.isViewDriveReport ? '#3249D7' : '#5db594'}!important;
  }
`
// export const CustomExportButton = styled(Button.Secondary)`
//   border: 1px solid #3249D7;
//   color: #3249D7;
//   height: 35px;

//   &:hover {
//     border: 1px solid #3249D7;
//     color: #3249D7;
//   }
//   &:focus {
//     border: 1px solid #3249D7;
//     color: #3249D7;
//   }
// `
